export default __webpack_public_path__ + "static/media/ram.08ab4f25.png";